import { render, staticRenderFns } from "./VideoTourValidatedModal.vue?vue&type=template&id=737517b2&scoped=true"
import script from "./VideoTourValidatedModal.vue?vue&type=script&lang=js"
export * from "./VideoTourValidatedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737517b2",
  null
  
)

export default component.exports